import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getDashboardOverview } from '../lib/api';
import { queryKeys } from '../lib/queryClient';

export function useDashboardOverview(token: string | null, schoolProfileId?: string) {
    return useQuery({
        queryKey: queryKeys.dashboard.overview(schoolProfileId),
        queryFn: () => getDashboardOverview(token!, schoolProfileId),
        enabled: !!token && !!schoolProfileId,
        staleTime: 1000 * 60 * 5,
    });
}

export function useInvalidateDashboard() {
    const queryClient = useQueryClient();

    return () => {
        queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all });
    };
}
